export function loginInNewTab() {
  window.open('/login-outside');
}
